import React from 'react';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';

interface Props {
	onSettingsClick: () => void;
}

const ManagerWorkplaceItemButtonsSettings = ({ onSettingsClick }: Props) => {
	return (
		<LinkButton
			theme={Theme.BLUE}
			onClick={onSettingsClick}
			title='component.workplaceAndWorkers.workplaceSettings'
			firstUpper
		/>
	);
};

export default ManagerWorkplaceItemButtonsSettings;
